import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaLink } from 'react-icons/fa';
import mastero from "../assets/payments/payment.png";
import visaIcon from '../assets/payments/visa.png';
import mastercardIcon from '../assets/payments/round.png';
import amexIcon from '../assets/payments/american-express.png';
import tapToPay from "../assets/payments/tap-to-pay.png";
import { toast } from 'react-toastify';
import axios from 'axios';
import { url } from '../utils/config';
import {  useRecoilValue } from 'recoil';

// Import Recoil State
import paymentDetailAtom from '../atoms/paymentDetailAtom';
import workOrderValueAtom from '../atoms/workOrderValueAtom';
import appointmentDetailsAtom from '../atoms/appointmentDetailsAtom';

const PaymentMode = () => {
  const navigate = useNavigate();
  const [isLinkDisabled, setIsLinkDisabled] = useState(false);
  const [countdown, setCountdown] = useState(60);
  
  const paymentDetail = useRecoilValue(paymentDetailAtom);
  const workOrder = useRecoilValue(workOrderValueAtom);
  const appointmentDetails = useRecoilValue(appointmentDetailsAtom);
  // Mock data - would come from props or state in real implementation
  const totalItems = 4;
  const totalAmount = 550.00;

  useEffect(() => {
    let timer;
    if (isLinkDisabled && countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
    } else if (countdown === 0) {
      setIsLinkDisabled(false);
      setCountdown(60);
    }
    return () => clearInterval(timer);
  }, [isLinkDisabled, countdown]);

  console.log(paymentDetail)

  const handlePaymentSelection = (method) => {
    // In a real app, you would process the payment here
    console.log(`Selected payment method: ${method}`);
    
    if (method === 'NFC') {
      // Navigate to tap to pay page for NFC
      navigate('/tap-to-pay');
    } else {
      // Navigate to confirmation page for other methods
      navigate('/payment_page');
    }
  };

  const paymentLinkHandler = async () => {
    if (isLinkDisabled) return;

    try {
      const token = window.localStorage.getItem('token');
      const headers = { authorization: `bearer ${token}` };
      const res = await axios.post(url + "/send_payment_link", {
        email: appointmentDetails?.pilot_user?.email,
        link: paymentDetail.paymentLink,
        phone: appointmentDetails?.pilot_user?.phone
      }, { headers });

      if (res.status === 200) {
        toast.success(res.data.message, { autoClose: 2000 });
        setIsLinkDisabled(true);
      } else {
        toast.error(res.data.message, { autoClose: 2000 });
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to send payment link", { autoClose: 2000 });
    }
  };
  
  return (
    <div className="h-[calc(100vh-64px)] flex flex-col bg-white pb-16">
     

      {/* Content */}
      <div className="flex-1 p-4 flex flex-col">
        {/* Order Summary */}
        <div className="bg-blue-600 text-white rounded-lg p-4 mb-6 flex justify-between items-center">
          <div className="font-medium">
            Total Amount | ${paymentDetail.amount.toFixed(2)}
          </div>
          <button 
            className="bg-white text-blue-800 px-4 py-1 rounded-md text-sm font-medium"
            onClick={() => navigate('/view_estimate')}
          >
            View Estimate
          </button>
        </div>

        {/* Payment Options */}
        <div className="space-y-3 mb-8">
          <div 
            className="bg-gray-100 rounded-lg p-4 flex items-center justify-between cursor-pointer hover:bg-gray-200 transition-colors"
            onClick={() => navigate('/payment-nfc')}
          >
            <span className="font-medium">NFC</span>
            <span>
                <img src={tapToPay} alt="Tap To Pay" className='h-6' />
            </span>
          </div>

          <div 
            className="bg-gray-100 rounded-lg p-4 flex items-center justify-between cursor-pointer hover:bg-gray-200 transition-colors"
            onClick={() => handlePaymentSelection('Card')}
          >
            <span className="font-medium">Card</span>
            <div className="flex space-x-2">
              <img src={amexIcon} alt="American Express" className="h-6" />
              <img src={visaIcon} alt="Visa" className="h-6" />
              <img src={mastercardIcon} alt="Mastercard" className="h-6 mix-blend-multiply" />
              <img src={mastero} alt="mastero" className='h-6 ' />
            </div>
          </div>

          <div 
            className={`bg-gray-100 rounded-lg p-4 flex flex-col cursor-pointer transition-colors
              ${isLinkDisabled ? 'opacity-75 cursor-not-allowed' : 'hover:bg-gray-200'}`}
            onClick={paymentLinkHandler}
          >
            <div className="flex items-center justify-between">
              <span className="font-medium">Request via Payment Link</span>
              <FaLink className="text-gray-500" />
            </div>
            
            {isLinkDisabled && (
              <div className="mt-2 text-sm">
                <p className="text-gray-600">
                  Payment link has been sent. Please wait {countdown} seconds before requesting again.
                </p>
                <div className="w-full bg-gray-200 h-1 mt-2 rounded-full overflow-hidden">
                  <div 
                    className="h-full bg-blue-500 transition-all duration-1000"
                    style={{ width: `${(countdown / 60) * 100}%` }}
                  ></div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Scan Product Button */}
        {/* <div className="mt-auto">
          <button 
            className="w-full bg-blue-600 text-white py-3 rounded-full font-medium text-lg hover:bg-blue-700 transition-colors"
            onClick={() => navigate('/scan')}
          >
            Scan Product
          </button>
        </div> */}
      </div>
      <div className="p-4">
        <button 
          onClick={() => navigate("/")}
          className="p-2 bg-gray-100 rounded-full"
        >
          <FaArrowLeft className="text-gray-700" />
        </button>
      </div>
    </div>
  );
};

export default PaymentMode;